// SmallMap.js
import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "150px",
  borderRadius: "8px",
};

const SmallMap = ({ coordinates }) => {
  if (!coordinates || coordinates.length !== 2) return null;

  const [lat, lng] = coordinates;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{ lat, lng }}
      zoom={13}
    >
      <Marker position={{ lat, lng }} />
    </GoogleMap>
  );
};

export default SmallMap;
